// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

const getAllVisiblePathIds = () => (dispatch, getState) => fromJS(
  getState().interferenceAnalysis.get('visibleGroupedFrequencyPlans')
    .reduce((a, d, i) => {
      d.forEach(p => a.push(p))
      return a
    }, [])
)

export default getAllVisiblePathIds
